'use strict';

(function (global) {

  /**
   * Действия над одностраничным документом - изображением.
   * (Поворот, масштабирование и прокрутка)
   *
   * @since 5.7.0
   */
  class ImageActions extends global.BaseImageActions {

    constructor(context) {
      super(context);
    }

    /**
     * Повернуть страницы документа в указанном направлении
     *
     * @method _rotatePages
     * @param {string} direction 'N' - север, 'E' - восток, 'S' - юг 'W' - запад
     * @private
     * @return {Core.preview.scrolling}
     */
    _rotatePages(direction) {
      this._direction = direction;
      this._jPlaceholder
        .removeClass('N E W S')
        .addClass(direction);
      // Применим отступы если страницы при повороте на π/2
      const shouldFlipHeightAndWidth = (this._direction === 'W' || this._direction === 'E');
      const sizeDiff = this._imageInitialSize.width - this._imageInitialSize.height;
      let transformStyle = '';

      if (shouldFlipHeightAndWidth) {
        if (this._direction === 'W') {
          transformStyle = `rotate(270deg) translateX(${- sizeDiff / 2}px)`;
        } else {
          transformStyle = `rotate(90deg) translateX(${sizeDiff / 2}px)`;
        }
      } else if (this._direction === 'S') {
        transformStyle = 'rotate(180deg)';
      }

      this._jPlaceholder.css({
        'transform': transformStyle,
      });
      this.setScale();

      return this;
    }

    /**
     * @see BaseActions.setScale
     */
    setScale(key = this._settings.previewScale) {
      super.setScale(key);

      this._recalculateSize(key);
      return this;
    }

    /**
     * Установить размер документа в соответствии с масштабом.
     *
     * @description Устанавливает css-свойста transform (scale), transform-origin и margin.
     * @method _recalculateSize
     * @param {string} key Масштаб.
     * @private
     */
    _recalculateSize(key) {
      let initHeight = this._imageInitialSize.height;
      let initWidth = this._imageInitialSize.width;
      let bodyWidth = initWidth;
      let viewportWidth = (window.visualViewport ? window.visualViewport.width : window.innerWidth);
      let isNeedMargin = false;

      let scale = this._calculateScaleRelativeToContainer(initWidth, initHeight, key);

      //если документ выровнен по ширине, либо шире чем viewport, то начальной точкой трансформации будем считать левый верхний край.
      let cssTransformOrigin = key === 'w' || scale * initWidth > viewportWidth ? 'left top' : 'center top';

      // FIXы для ie, т.к. в нем при изменении масштаба размер контейнера не изменятеся
      if (WA.ENV.browser.name === 'IE') {
        this._html.css({
          overflowX: 'auto',
        });
      } else if (scale < 1 || key === 'w') {
        // Данный хак убирает пустое место в предпросмотре снизу. Данный дефект проявляется везде, кроме IE.
        this._html.height(0);
        this._jFrame.contents().find('body').css({
          height: 0,
        });
      }

      if (initWidth > viewportWidth && key !== 'w') {
        this._jFrame.contents().find('body').css({
          width: (key === 'h' || key === 'a' || initWidth * scale < viewportWidth ? "" : bodyWidth),
        });
        // margin - в основном костыль для починки ширины плейсхолдера при использовании сервиса
        this._jPlaceholder.css('margin', ''); // чистим чтобы получить исходные размеры элементов
        this._jPlaceholder.css({
          'margin': `auto ${(this._jPlaceholder.width() - (this._imageInitialSize.width + 2 * this._placeholderMargin)) / 2}px`,
          'margin-top': `${this._placeholderMargin / scale}px`,
        });
      } else {
        isNeedMargin = true;
        this._jPlaceholder.css('margin', ''); // чистим чтобы получить исходные размеры элементов
        bodyWidth = viewportWidth < initWidth ? initWidth : "";
        //HACK: При повороте изображение не всегда влазит в текущий viewport. 
        //      Для корректного отображения нужно ширину сделать равной высоте.
        this.shouldFlipHeightAndWidth = (this._direction === 'W' || this._direction === 'E');
        if (this.shouldFlipHeightAndWidth && initHeight > initWidth) {
          bodyWidth = (scale > 1 ? initHeight * scale : initHeight);
        }
        this._jFrame.contents().find('body').css({
          width: bodyWidth,
        });
      }

      //HACK: Нужно переопределить стили для выравнивания документов по ширине окна, 
      //      иначе при переключении выравнивания они уезжают.
      super._setSizesToHtmlAndBody(key, this.shouldFlipHeightAndWidth ? bodyWidth : initWidth, scale, cssTransformOrigin, isNeedMargin);

      requestAnimationFrame(() => {
        if (this._isIpad) {
          const padding = 20; // отступы страниц картинок 20px
          const frameBodyWidth = this._jFrame.contents().find('img:first').width() * scale + padding;
          let totalHeight = 0;
          this._jFrame.contents().find('body').children().each((index, element) => {
            totalHeight += element.offsetHeight + padding;
          });
          const minWidth = this._jFrame.parent().width() - 17;
          const frameBodyHeight = totalHeight * scale + padding;
            this._jFrame.css({
              backgroundColor: 'initial',
              height: `${frameBodyHeight}px`,
              marginBottom: '-4px',
              minWidth: `${minWidth}px`,
              width: `${frameBodyWidth}px`,
            });

          const marginLeft = minWidth > frameBodyWidth ? (minWidth - frameBodyWidth) / 2 : 10;
          this._html.css({
            margin: `10px 10px 10px ${marginLeft}px`,
            overflow: 'hidden',
            transformOrigin: 'left top',
          });
        }
      });
    }

    /**
    * @see BaseActions.printDocFromPreview
    */
    printDocFromPreview() {
      // изначально в предпросмотре подгружаются первые две страницы,
      // поэтому для не подгруженных проставим корректный класс и src
      const tmpWindow = window.open('', 'PRINT', '');
      const jContentDoc = $('#contentContainer').get(0).contentDocument;

      // у первой страницы есть нормальный src, который можно использовать
      const jPrimaryImg = $(jContentDoc).find('.previewImage').get(0);
      const imgSrc = jPrimaryImg.src.replace(window.location.origin, '');
      const spinnerText = L("PREPEARING_DOC_FOR_PRINT");

      const pages = $('.placeholder', jContentDoc).get();

      let allPages = [];
      let pageNum = 1;
      let pagesLoaded = 0;
      let customBody = '';

      pages.forEach((page) => {
        const images = $('img', page).get();
        images.forEach((img) => {
          let downloadingImage = new Image();
          downloadingImage.onload = function () {
            const me = this;
            // TODO: здесь надо получить размеры загруженной картинки и понять надо ли ее повернуть при формировании page
            // me.naturalWidth; me.naturalHeight;
            me.style = 'height: 100%; width: 100%; object-fit: contain; overflow: hidden;';
            allPages[me.id] = `<div style='page-break-after: always; height: 100%; width: 100%;'>${me.outerHTML}</div>`;
            pagesLoaded++;

            if (pagesLoaded === pages.length) {
              allPages.forEach((printPage) => {
                customBody += printPage;
              });

              const customHTML = `
                <html lang="ru">
                  <head>
                    <link rel="stylesheet" type="text/css" href="/css/preview_print.css" />
                    <link rel="stylesheet" type="text/css" href="/css/wait-page.css" />
                    <script type="text/javascript">
                      function scriptOnLoad(){
                        var spinnerDiv = document.getElementsByClassName('spinner-container')[0]; 
                        spinnerDiv.parentNode.removeChild(spinnerDiv); 
                        var pages = document.getElementsByTagName('img'); 
                        for (var i = 0; i < pages.length; i++) { 
                          pages[i].style.opacity = 1; 
                        }
                        window.print();
                        ${!this._isIpad && !WA.ENV.isAndroid() ? 'window.close();' : ''}
                      }
                    </script>
                  </head>
                  <body onload="scriptOnLoad(); ">
                    <div class="spinner-container">
                      <div class="spinner">
                        <img class="spinner__ring" src="../svg/WillNotBeBaked/pic-loading-ring.svg" alt="">
                        <img class="spinner__logo" src="../svg/WillNotBeBaked/pic-logo.svg" alt="">
                        <span class="spinner__text">&nbsp;${spinnerText}...</span> 
                      </div> 
                    </div>
                    ${customBody}
                  </body>
                </html>`;
              tmpWindow.document.write(customHTML);
              tmpWindow.document.close();
            }
          }
          downloadingImage.src = imgSrc.replace('1/?undefined', (pageNum).toString());
          downloadingImage.id = pageNum;
          pageNum++;
        });
      });
    }
  }

  global.ImageActions = ImageActions;
})(window.Core.preview);